import { render, staticRenderFns } from "./eventsItem.vue?vue&type=template&id=0871c21b&"
import script from "./eventsItem.vue?vue&type=script&lang=js&"
export * from "./eventsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports